import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDegreeData } from "../../redux/slicer/degreeSlice";
import { BiSolidRightArrow } from "react-icons/bi";
import { GiGraduateCap } from "react-icons/gi";
import { FaPhoneAlt } from "react-icons/fa";
import Background from "../../assets/background_2.png";
import parse from "html-react-parser";
import { useLocation, useNavigate } from "react-router-dom";
import sqlFile from "./Registration.pdf"; // Adjust the path to your file
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

function Degree() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const degreeId = searchParams.get("id");

  const dispatch = useDispatch();
  const {
    data: degreeData,
    loading,
    error,
  } = useSelector((state) => state.degree.degree);
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (!degreeData.length) {
      dispatch(fetchDegreeData());
    }
  }, [dispatch, degreeData.length]);

  const handleApplyNowClick = () => {
    setShowModal(true); // Show the modal when "Apply Now" is clicked
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const closeModal = () => {
    setShowModal(false); // Close the modal
  };

  const handleApplyOnline = () => {
    navigate(
      `/degree-registration?id=${degree.id}&name=${degree.program_name}`
    ); // Navigate to the route
    closeModal(); // Optionally close the modal
  };

  const handleDownloadApplication = () => {
    // Handle the download application logic here
    alert("Downloading application...");
    closeModal();
  };

  const degree = degreeData.find((d) => d.id === parseInt(degreeId));

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!degree) return <div>Degree not found</div>;

  const renderListItems = (htmlContent) => {
    const parsedContent = parse(htmlContent);
    return (
      <ul className="list-disc ml-5">
        {Array.isArray(parsedContent) ? (
          parsedContent.map((item, index) => (
            <li key={index} className="mb-2">
              {item}
            </li>
          ))
        ) : (
          <li>{parsedContent}</li>
        )}
      </ul>
    );
  };

  return (
    <div>
      {/* Header Section */}
      <div className="relative max-w-full mx-auto">
        <div className="overflow-hidden w-full h-[200px] sm:h-[300px] md:h-[400px]">
          <img
            src="https://files.unitasterdays.com/bespoke-pages/bpid654/img2023816670.jpg"
            alt="carousel-slide"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold font-titillium">
              {degree.program_name}
            </h2>
            <p className="text-sm sm:text-lg mt-2 sm:mt-10 bg-img-description  font-titillium"></p>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="px-4 sm:px-8 lg:px-28 py-6 mt-6 grid gap-y-6 font-inter">
        <p className="text-justify">{parse(degree.description)}</p>

        <div className="text-left py-6">
          <button
            className="rounded text-white bg-primary-color w-[120px] sm:w-[150px] h-[40px] flex items-center justify-center gap-2"
            onClick={handleApplyNowClick}
          >
            <span className="font-inter">Apply Now</span>
            <BiSolidRightArrow />
          </button>
        </div>

        {/* Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full relative">
              {/* Close Button */}
              <button
                className="absolute top-3 right-3 text-primary-color text-2xl"
                onClick={closeModal}
              >
                &times;
              </button>

              {/* Modal Content */}
              <div className="text-center">
                <p className="text-lg font-medium mb-4 font-inter">
                  Choose one option:
                </p>

                <div className="flex justify-center gap-4">
                  {/* Download Application Button */}
                  <a
                    href={sqlFile} // Replace with your PDF path
                    download
                    className="rounded bg-primary-color text-white px-4 py-2 flex items-center gap-2 font-inter"
                  >
                    Download Application
                    <BiSolidRightArrow />
                  </a>

                  {/* Apply Online Button */}
                  <button
                    className="rounded bg-primary-color text-white px-4 py-2 flex items-center gap-2 font-inter"
                    onClick={handleApplyOnline}
                  >
                    Apply Online
                    <BiSolidRightArrow />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Degree Details */}
        {/* <div>
          <h2 className="text-left text-sm sm:text-base font-inter">
            The {degree.program_name} Degree is designed under two stages:
          </h2>
          <div>
            <div className="ml-4 sm:ml-6 flex items-center space-x-2 mt-3">
              <div className="text-primary-color text-xl sm:text-2xl">
                <GiGraduateCap />
              </div>
              <h2 className="text-left ml-2 text-sm sm:text-base font-inter">
                {degree.program_name} – {degree.offering_university}
              </h2>
            </div>
          </div>
        </div> */}

        {/* Eligibility Section */}
        <div className="flex justify-center ml-12 pl-12 mt-5 md:hidden">
          <div className="border rounded border-primary-color w-[300px] sm:w-[350px] h-10 flex items-center justify-center hidden md:flex">
            <h2 className="font-bold text-primary-color text-sm sm:text-base font-titillium ">
              Eligibility Criteria
            </h2>
          </div>
        </div>
        <div className="flex flex-col items-center xl:items-start md:grid md:grid-cols-1 xl:grid-cols-2 gap-6 mt-5">
          {/* Image Section */}
          <div className="w-full h-auto flex flex-col items-center xl:items-start">
            <div className="grid grid-rows-12 gap-4">
              {/* Large Image */}
              <div className="row-span-6 flex justify-center xl:justify-start">
                <div className="rounded overflow-hidden w-full md:w-[440px] h-[140px] ">
                  <img
                    src="https://files.unitasterdays.com/bespoke-pages/bpid654/img2023816670.jpg"
                    alt="carousel-slide"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
              {/* Small Images Row */}
              <div className="row-span-6 flex justify-center xl:justify-start">
                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-7 flex justify-center xl:justify-start">
                    <div className="rounded overflow-hidden w-full md:w-[250px] h-[150px] ">
                      <img
                        src="https://c8.alamy.com/comp/2BX2E2T/a-young-female-graduate-against-the-background-of-university-graduates-2BX2E2T.jpg"
                        alt="carousel-slide"
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                  </div>
                  <div className="col-span-5 flex justify-center xl:justify-start">
                    <div className="rounded overflow-hidden w-full md:w-[180px] h-[150px] ">
                      <img
                        src="https://www.rmit.edu.au/content/dam/rmit/au/en/students/images/student-life/events/student-life-events-promo-ref.jpeg"
                        alt="carousel-slide"
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Eligibility Criteria Section */}
          <div className="w-full flex flex-col mt-4 xl:mt-0 xl:ml-4 items-center justify-center">
            <div className="border rounded border-primary-color w-[150px] sm:w-[200px] h-10 flex items-center justify-center py-1">
              <h2 className="text-primary-color font-bold text-sm sm:text-base font-titillium">
                Eligibility Criteria
              </h2>
            </div>
            <ul className="list-disc font-bold text-justify grid gap-y-2 pr-4 sm:pr-10 font-inter w-full">
              {renderListItems(degree.eligibity_criteria)}
            </ul>
          </div>
        </div>

        {/* Additional Sections */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-6">
            <div className="flex mt-5">
              {/* <div className="border rounded border-primary-color w-[150px] sm:w-[200px] h-10 flex items-center justify-center py-1 mx-auto lg:mx-0">
                <h2 className="font-bold text-primary-color font-titillium">
                  Admission Criteria
                </h2>
              </div> */}
            </div>
            {/* <div className="mt-4">
              <ul className="list-disc font-bold text-justify space-y-2 ml-3 font-inter">
                {renderListItems(degree.admission_criteria)}
              </ul>
            </div> */}
            <div className="flex mt-5">
              <div className="border rounded border-primary-color w-[120px] sm:w-[150px] h-10 flex items-center justify-center py-1 mx-auto lg:mx-0">
                <h2 className="font-bold text-primary-color font-titillium">
                  Investment
                </h2>
              </div>
            </div>
            <div className="mt-4">
              <ul className="list-disc font-bold text-justify space-y-2 ml-3 font-inter">
                {renderListItems(degree.investment)}
              </ul>
            </div>
            {degree.file_urls.length > 0 && (
              <div className="mt-5">
                <h2 className="font-bold text-primary-color ml-3 text-left font-titillium">
                  Supporting Documents
                </h2>
                <ul className="list-disc font-bold text-justify space-y-2 ml-5 mt-4">
                  {degree.file_urls.map((url, index) => {
                    //Split by comma(,) and select the document from upload_path
                    const uploadPathArray = degree.upload_path.split(",");
                    let documentName = `Document ${index + 1}`;

                    if (uploadPathArray[index]) {
                      //Check the array to avoid undefiend value
                      documentName = uploadPathArray[index].split("-").pop();
                    }
                    return (
                      <li key={index}>
                        <a
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 underline"
                        >
                          {documentName || `Document ${index + 1}`}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            {/* {degree.file_urls.map((url, index) => {
        //Split by comma(,) and select the document from upload_path
        const uploadPathArray = degree.upload_path.split(',');
        let documentName = `Document ${index + 1}`;

        if (uploadPathArray[index]) { //Check the array to avoid undefiend value
          const parts = uploadPathArray[index].split('-');
          if (parts.length >= 2) {
            documentName = parts.slice(-2).join('-'); // Take last two parts and join by hyphen
          } else {
            documentName = parts[0]; // Use the whole thing if fewer than 2 parts
          }
        }
        return (
          <li key={index}>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 underline"
            >
              {documentName || `Document ${index + 1}`}
            </a>
          </li>
        )
      })}
    </ul>
  </div>
)} */}
          </div>

          <div className="lg:col-span-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="overflow-hidden rounded-lg w-full h-[200px] sm:h-[250px] md:h-[350px]  mx-auto">
                <img
                  src="https://www.universitiesuk.ac.uk/sites/default/files/styles/content_banner_on_desktop/public/image-upload/getti/students-iStock-482117740.jpg?h=38ee85f3&itok=rzkiJtSB"
                  alt="carousel-slide"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="grid grid-rows-2 gap-4">
                <div className="overflow-hidden rounded-lg w-full h-[100px] sm:h-[130px]  mx-auto">
                  <img
                    src="https://www.sjp.ac.lk/wp-content/uploads/2022/02/IMG-20220218-WA0003.jpg"
                    alt="carousel-slide"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div className="overflow-hidden rounded-lg w-full h-[120px] sm:h-[160px]  mx-auto">
                  <img
                    src="https://www.ulusofona.pt/images/estudante-internacional_628.jpg"
                    alt="carousel-slide"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="flex item-start justify-start mb-8">
          <div className="flex items-center justify-center gap-2">
            <h2 className="text-primary-color font-inter font-bold">
              For more information :
            </h2>
            <h2 className="flex items-center justify-center gap-2 font-bold ml-5">
              <FaPhoneAlt />
              0710 235 263 | 0112 807 407
            </h2>
          </div>
        </div>
      </div>
      {/* <div className="px-6 pt-4 pb-2 flex justify-end mb-5">
        <button
          onClick={scrollToTop}
          className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px] text-2xl"
        >
          <FaArrowUp />
        </button>
      </div> */}

      {/* <div className="relative max-w-full mx-auto ">
        {" "}
        <div className="relative w-full overflow-hidden">
          <img
            src={Background}
            alt="img"
            className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover object-center"
          />
        </div>
      </div> */}
    </div>
  );
}

export default Degree;
